// Logical resolution. Width is fixed at BASE_W on desktop; a portrait (mobile)
// box shrinks the logical space by MOBILE_ZOOM for a zoomed-in view. Height is
// derived from the on-screen box so the pixel buffer never skews.
export const BASE_W = 480;
export const MOBILE_ZOOM = 1.25;
export const DESKTOP_H = 360;
export const MOBILE_H = 640;

export const SUN_X = 120;
export const SUN_R = 13;
export const GRAVITY = 430; // px/s^2, always pulling the sun down
export const THRUST = 760; // px/s^2 applied upward while held
export const MAX_VY = 300;
export const GROUND_H = 48; // panel strip height at the bottom
export const CLOUD_W = 54; // nominal cloud width (column spacing/scoring)
export const CLOUD_W_MAX = 90; // widest a cloud can be (off-screen culling)
export const MARGIN = 22; // keep openings reachable away from ceiling/ground
export const MIN_CLOUD_H = 18;
export const MAX_CLOUD_H = 78;
export const BATTERY_R = 9;
export const MULT_MAX = 5; // highest battery combo multiplier
export const MULT_TIME = 6; // seconds a multiplier lasts before decaying to 1
export const MILESTONES = [10, 25, 50, 100]; // kWh thresholds that trigger a celebration
export const STAR_COUNT = 60;

// One game-second models a few real minutes of generation so the kWh figures
// feel rewarding while staying honestly labelled (see the Accuracy-Trap note).
export const TIME_SCALE = 150;
